import { FC, useCallback, useContext, useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { Breadcrumb, Notification, Popover } from "@douyinfe/semi-ui";
import { IndexContext } from "@/stores";
import Link from "next/link";
import { useRouter } from "next/router";
import { NavType } from "../navbar";
import cName from "classnames";
import { IconChevronRight } from '@douyinfe/semi-icons';
import MyModal from "../modal";
import axios from 'axios';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import classNames from "classnames";
import Head from "next/head";
/**
 * 导航目录是早期写的，写的比较乱，也没时间重构，将就看
 */

type CrumbType = {
  path: string,
  name: string,
}

export interface ILayoutProps {
  type?: string,
  crumb?: CrumbType[]
  isCrumb?: boolean
  newsPath?: string | undefined | null;
}


export const PageLayout: FC<ILayoutProps & { children: JSX.Element }> = ({
  children,
  type = 'default',
  isCrumb = true,
  crumb = [],
  newsPath
}) => {
  const { nav, lang } = useContext(IndexContext)
  const [menu, setMenu] = useState<NavType>()
  const [active, setActive] = useState<NavType>()
  const router = useRouter()
  const [visible, setVisible] = useState(false)
  const [isHidden, setIsHidden] = useState(false)
  const [isSearch, setIsSearch] = useState(false)
  const bgStyle = {
    'online': {
      bgColor: '#fafafa',
      bgImage: '/image/page-banner2.png?v=2025'
    },
    'detail': {
      bgColor: '#fafafa',
      bgImage: '/image/page-banner3.png?v=2025'
    },
    'default': {
      bgColor: 'white',
      bgImage: '/image/page-banner.png?v=2025'
    }
  } as any

  const navTo = useCallback((e: any, item: NavType): void => {
    if (router.asPath == item.path) {
      return
    }
    e.stopPropagation();
    // if (item.path === '/audience/register') {
    //   setVisible(true)
    //   return
    // }
    if (item.outlink) {
      const a = document.createElement("a")
      a.href = `${item.outlink}`
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      return
    }
    router.push(item.path as any, item.path as any, {
      shallow: true
    })
  }, [active, nav])

  const searchNode = (data: any, path: string) => {
    for (let i = 0; i < data?.length; i++) {
      const item = data[i];
      if (item.path === path) {
        return item;
      }

      if (item.children && Array.isArray(item.children)) {
        const found = searchNode(item.children, path) as any;
        if (found) {
          return found;
        }
      }
    }

    return null;
  };

  useEffect(() => {
    const { text } = router.query;
    setIsSearch(!!text)
  }, [router.query])

  useEffect(() => {
    const act = searchNode(nav, newsPath || router.asPath)
    setActive(act)
    const item = nav?.find(item => item.id === act?.parent)
    setMenu(item)
    console.log(act, menu);


  }, [nav])


  return (
    <div
      className={styles.page}
      style={{ backgroundColor: bgStyle[type].bgColor }}
    >
      {isCrumb && <div className={styles.banner}>
        <img src={bgStyle[type].bgImage} alt="" />
        {/* {type === 'online' ? (<div className={styles.onlineCruTitle}>
          <h1><span>{menu?.name || active?.name}</span><span className={styles.shade}>{menu?.name}</span></h1>
        </div>) : (
          <div className={styles.cruTitle}>
            <h1><span>{menu?.name || active?.name}</span><span className={styles.shade}>{menu?.name}</span></h1>
          </div>
        )} */}
      </div>}


      {isCrumb && <div className={styles.pageHeader}
        style={{ marginTop: `${type === 'online' ? '-18%' : '0'}` }}
      >
        <div className={cName(styles.floatBox, {
          [styles.isHidden]: isHidden
        })}>
          <div className={styles.list}>
            <Popover
              showArrow
              style={{
                backgroundColor: '#F9B000',
                padding: '15px 15px 10px',
                width: '230px',
              }}
              content={
                <div>
                  <img style={{ width: '100%' }} src="/image/help-qrcode.png" alt="" />
                  <p style={{ fontSize: '14px', color: 'white', textAlign: 'center', marginTop: '5px' }}>更多资讯，关注CBCE小助手</p>
                </div>
              }
              position="left"
            >
              <div className={styles.wechat}><p>小助手</p><hr /></div>
            </Popover>
            <a href="/exhibition/apply" target="_self">
              <div className={styles.apply}>
                <p>我要参展</p>
                <hr />
              </div>
            </a>
            <a href="https://cbce2025.gration.cn/?member/register&code=sites" target="_blank">
              <div className={styles.register}>
                <p>我要参观</p>
                <hr />
              </div>
            </a>
            {/* <div className={styles.contact}><p>联系</p><hr /></div> */}
            <div className={styles.toTop} onClick={() => window.scrollTo(0, 0)}><p>顶部</p></div>

          </div>
          <div className={styles.btn} onClick={() => setIsHidden(!isHidden)}>
            {/* @ts-ignore */}
            <svg t="1723196878237" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672">
              <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#fff">
              </path>
            </svg>
            <span>隐藏</span>
          </div>
        </div>
        <div className={styles.crumb}>
          <img src="/image/home.png" alt="" />
          <Breadcrumb
            routes={
              [
                {
                  path: '/',
                  name: '首页'
                },
                {
                  path: active?.path || menu?.path || '',
                  name: menu?.name || '',
                  isShow: !menu
                },
                {
                  path: active?.path || '',
                  name: active?.name || '',
                  isShow: !active
                },
                ...crumb
              ].filter((item: any) => !item.isShow) as any
            }
            onClick={(item) => {
              router.push(item.path as any, item.path as any, {
                shallow: true
              })
            }
            }
            separator={'>'} />
        </div>
        {
          menu?.children
          && menu.children.length > 1
          && (
            menu.children.length == 1 ? <h1>{menu?.children[0].name}</h1> : (
              <ul className={cName([styles.pageNav])}>
                {
                  menu?.children?.map(item => (

                    <li key={item.id}
                      className={classNames({ [styles.active]: item.id === active?.id })}
                      onClick={(e) => navTo(e, item)}>{item.name}</li>
                  ))
                }
              </ul>
            )
          )
        }
        <Swiper
          className={cName([styles.swiper, "crumb"])}
          modules={[]}
          // spaceBetween={30}
          slidesPerView='auto'
          style={{ display: 'none' }}
        >
          {
            menu?.children
            && menu.children.length > 1
            && (
              menu.children.length == 1 ? <h1>{menu?.children[0].name}</h1> : (
                <div>
                  {
                    menu?.children?.map(item => (
                      <SwiperSlide key={item.id}>
                        <div
                          className={classNames({ [styles.swiperList]: true, [styles.active]: item.id === active?.id })}
                          onClick={(e) => navTo(e, item)}>{item.name}</div>
                      </SwiperSlide>
                    ))
                  }
                </div>
              )
            )
          }

          <SwiperSlide></SwiperSlide>
        </Swiper>
      </div>}
      <div className={cName([styles.content, 'content'])}>
        <div>
          <div style={{ width: '100%' }}>
            {children}
          </div>
        </div>
        <MyModal visible={visible} onOk={() => setVisible(false)}></MyModal>
      </div>
      <style jsx global>
        {
          `
            .semi-breadcrumb-item-active span{
              color: #F08200 !important; 
            }
            .semi-breadcrumb-item span{
              font-weight:500;
              font-size:16px;
            }
            .crumb .swiper-slide{
              width:auto;
            }
            .semi-image-preview-image-img{
              max-width:none !important;
            }
          `
        }
      </style>
    </div >
  );
};
